exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donautocomplete{position:relative;text-align:left}.donautocomplete .donautocomplete-list{position:absolute;z-index:9999;background-color:#fff;max-height:250px;overflow:auto;width:100%;border:1px solid #ccc;border-radius:3px}.donautocomplete .donautocomplete-list .donautocomplete-list-item{cursor:pointer}.donautocomplete .donautocomplete-list .donautocomplete-list-item.donautocomplete-item-active{color:#fff;background-color:var(--primaryColor)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/global/autocomplete/don.autocomplete.vue
// module id = 77
// module chunks = 5